import './FamilyTreeDiagram.scss';

import { ExtendedRelationship } from '@customTypes/constants';
import { getRelationshipLabel } from '@helpers/subject';

interface EligibilityGroup {
  label: string;
  relationships: readonly ExtendedRelationship[];
}

const ELIGIBILITY_GROUPS: EligibilityGroup[] = [
  {
    label: '1st degree',
    relationships: ['PARENT', 'SIBLING', 'HALF_SIBLING', 'CHILD'],
  },
  {
    label: '2nd degree',
    relationships: ['GRANDPARENT', 'GRANDCHILD', 'AUNT_UNCLE', 'NIECE_NEPHEW'],
  },
  {
    label: '3rd-4th degree',
    relationships: ['FIRST_COUSIN', 'OTHER'],
  },
];

export const FamilyTreeDiagram = () => (
  <figure className='fvt-family-tree' aria-labelledby='fvt-family-tree-heading'>
    <figcaption id='fvt-family-tree-heading' className='fvt-family-tree__heading'>
      Who is eligible?
    </figcaption>
    <p className='fvt-family-tree__lede'>
      Blood relatives up to 4th degree - parents, siblings, children, and more distant blood relatives.
    </p>

    <div
      className='fvt-family-tree__diagram'
      role='img'
      aria-label='Eligible relatives grouped by degree: 1st, 2nd, and 3rd to 4th degree'
    >
      <span className='fvt-family-tree__node fvt-family-tree__node--proband'>You</span>

      {ELIGIBILITY_GROUPS.map(group => (
        <div key={group.label} className='fvt-family-tree__group'>
          <span className='fvt-family-tree__group-label'>{group.label}</span>

          <div className='fvt-family-tree__chips'>
            {group.relationships.map(relationship => (
              <span key={relationship} className='fvt-family-tree__node fvt-family-tree__node--muted'>
                {getRelationshipLabel(relationship)}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  </figure>
);
